<template>
  <div>
    <appHeader></appHeader>
    <b-overlay
      no-center
      :show="show"
      spinner-variant="primary"
      rounded="sm"
      class="w-100"
    >
      <div class="container-fluid p-3 product-page">
        <div class="row">
          <div class="col-12 col-lg-3 col-sm-12">
            <appProductSidebar></appProductSidebar>
          </div>
          <b-spinner
            v-if="showSpinner"
            variant="primary"
            label="Spinning"
            class="mt-5 row"
          ></b-spinner>
          <template v-else>
            <div
              v-for="(product, index) in redirectProducts"
              v-bind:key="index"
              class="mt-5 product col-lg-3 col-md-4 col-sm-6 col-xs-12"
            >
              <b-button @click="showRedirectNotice(1800, index)">
                <div class="image">
                  <img
                    :src="products.find((p) => p.name == product.name).imageUrl"
                    class=""
                  />
                </div>
                <p class="name">{{ product.name }}</p>
              </b-button>
              <!--Hidden Form for redirection -->
              <form ref="form" method="GET" :action="product.url">
                <template v-for="(value, key) in product.body">
                  <input
                    v-bind:key="key"
                    type="hidden"
                    :name="key"
                    class="form-control"
                    :value="value"
                  />
                </template>
              </form>
            </div>
          </template>
        </div>
      </div>
      <template #overlay>
        <div
          class="position-absolute font-weight-bold"
          style="top: 10%; right: 30%"
        >
          <h3>Redirecting to Divvy Events and Experiences...</h3>
        </div>
      </template>
    </b-overlay>
    <appFooter></appFooter>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ProductSidebar from "./ProductSidebar.vue";
import { mapState } from "vuex";

export default {
  name: "TicketAndExperiences",
  components: {
    appHeader: Header,
    appFooter: Footer,
    appProductSidebar: ProductSidebar,
  },
  data() {
    return {
      userProfile: {},
      exclusiveItem: {},
      showSpinner: true,
      show: false
    };
  },
  methods: {
    async showRedirectNotice(milliseconds, index) {
      // show overlay with redirection notice for  the passed-in amount of milliseconds
      this.show = true;
      await new Promise((resolve) => setTimeout(resolve, milliseconds));
      this.show = false;

      // redirect to the next
      this.submit(index);
    },
    submit(index) {
      this.$refs.form[index].submit();
    },
  },
  computed: {
    ...mapState({
      exclusiveCategories: (state) => state.category.exclusives,
      products: (state) => state.product.items,
      companyName: (state) => state.company.name,
    }),
    // Used for products that redirect to other websites and pass data
    redirectProducts() {
      return [
        {
          name: "Ticket and Experiences",
          url: "https://divvytj.com",
          body: {
            pid: this.companyName, // pid is the name of the company and ticket jones uses this to get the correct point conversion ratio
            uid: this.userProfile.id,
            balance: this.userProfile.pointsAvailable,
          },
        },
      ];
    },

    exclusiveCategory() {
      const item = this.exclusiveCategories.Find(
        (item) => item["type"] === "TICKETSANDEXPERIENCES"
      );
    },
  },
  async created() {
    this.userProfile = this.$store.getters["user/getUserProfile"];

    await this.$store.dispatch("company/fetchCompany");

    await this.$store.dispatch("category/fetchExclusives");

    // getting category ID so we can get the products and product images
    const exclusiveCategoryId = this.exclusiveCategories.find(
      (item) => item["type"] == "TICKETSANDEXPERIENCES"
    ).categoryId;

    await this.$store.dispatch("product/fetchProducts", {
      categoryId: exclusiveCategoryId,
      // searchFilter: searchFilter,
      // sortOrder: sortOrder,
      // page: currentPage,
    });

    this.showSpinner = false;

    // Keeping this here for debugging purposes
    console.log(this.companyName);
  },
};
</script>

<style lang="scss">
@media all and (max-width: 450px) {
  .product {
    .image {
      float: left;
      margin-right: 16px;
      max-width: 40%;
      height: 100%;
      width: 40%;
      overflow: hidden;
      border: none;
      height: 190px;
      img {
        max-width: 100%;
        max-height: 150px;
        margin: auto;
      }
    }
  }
}
</style>
